var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "base" },
    [
      _c("div", { staticClass: "card-title" }, [_vm._v("意见反馈")]),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-cell" }, [
          _vm._m(0),
          _c("div", { staticClass: "cell-content" }, [
            _vm._v(_vm._s(_vm.dataObj.title))
          ])
        ]),
        _c("div", { staticClass: "card-cell textarea-cell" }, [
          _vm._m(1),
          _c("div", { staticClass: "cell-content" }, [
            _vm._v(_vm._s(_vm.dataObj.content))
          ])
        ])
      ]),
      _c("div", { staticClass: "interval" }),
      _c("div", { staticClass: "card-title" }, [_vm._v("反馈图片")]),
      _c("div", { staticClass: "card" }, [
        _vm.fileList.length > 0
          ? _c(
              "div",
              { staticClass: "card-cell imgs-cell" },
              _vm._l(_vm.fileList, function(item, index) {
                return _c("img", {
                  key: index,
                  staticClass: "up-img",
                  attrs: { src: item },
                  on: {
                    click: function($event) {
                      return _vm.showImg(item)
                    }
                  }
                })
              }),
              0
            )
          : _vm._e(),
        _vm.fileList.length == 0
          ? _c("div", { staticClass: "card-cell imgs-cell" }, [
              _c("div", { staticClass: "no-img" }, [_vm._v("未上传现场照片")])
            ])
          : _vm._e()
      ]),
      _vm.dataObj.status == "1"
        ? [
            _c("div", { staticClass: "card-title" }, [_vm._v("处理结果")]),
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-cell textarea-cell" }, [
                _vm._m(2),
                _c("div", { staticClass: "cell-content" }, [
                  _vm._v(_vm._s(_vm.dataObj.handleContent))
                ])
              ]),
              _c("div", { staticClass: "card-cell" }, [
                _vm._m(3),
                _c("div", { staticClass: "cell-content" }, [
                  _vm._v(_vm._s(_vm.dataObj.handleUserId_dictText))
                ])
              ]),
              _c("div", { staticClass: "card-cell" }, [
                _vm._m(4),
                _c("div", { staticClass: "cell-content" }, [
                  _vm._v(_vm._s(_vm.dataObj.handleTime))
                ])
              ])
            ]),
            _c("div", { staticClass: "footer" })
          ]
        : _vm._e(),
      _c(
        "mt-popup",
        {
          model: {
            value: _vm.showImgFlag,
            callback: function($$v) {
              _vm.showImgFlag = $$v
            },
            expression: "showImgFlag"
          }
        },
        [_c("img", { staticClass: "big-img", attrs: { src: _vm.tempImgUrl } })]
      )
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cell-title" }, [
      _c("span", { staticClass: "required" }, [_vm._v("*")]),
      _c("span", [_vm._v("反馈标题")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cell-title" }, [
      _c("span", { staticClass: "required" }, [_vm._v("*")]),
      _c("span", [_vm._v("反馈内容")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cell-title" }, [
      _c("span", { staticClass: "required" }, [_vm._v("*")]),
      _c("span", [_vm._v("处理内容")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cell-title" }, [
      _c("span", { staticClass: "required" }, [_vm._v("*")]),
      _c("span", [_vm._v("处理人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cell-title" }, [
      _c("span", { staticClass: "required" }, [_vm._v("*")]),
      _c("span", [_vm._v("处理时间")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }